// src/pages/PaymentCancelledPage.js

import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const PaymentCancelledPage = () => {
    return (
        <>
            <Helmet>
                <title>Payment Cancelled</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
                <div className="col-md-6 col-lg-5" style={{ maxWidth: '500px' }}>
                    <div className="card shadow-sm border-0 text-center p-4">
                        <i className="bi bi-exclamation-circle-fill text-warning mb-3" style={{ fontSize: '4rem' }}></i>
                        <h1 className="fw-bold">Payment Cancelled</h1>
                        <p className="lead text-muted mb-4">
                            It looks like you've cancelled the payment process. Your card has not been charged.
                        </p>
                        <p className="text-muted">
                            If you'd like to try again or have any questions, please feel free to reach out.
                        </p>
                        <div className="d-grid gap-2 mt-4">
                            <Link to="/signup" className="btn btn-primary">
                                Try Subscription Again
                            </Link>
                            <Link to="/" className="btn btn-outline-secondary">
                                Return to Homepage
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentCancelledPage;